import { logger } from 'src/services';
import { getAppConfigApi } from 'src/api';
import { create } from 'zustand';
import { AppConfig } from 'src/models';
import { AxiosError } from 'axios';

type ConfigStore = {
  loading: boolean;
  error: { code?: number; message?: string } | null;
  config: Partial<AppConfig>;
  getConfig: (payload: { chatToken: string }) => Promise<void>;
};

export const useConfigStore = create<ConfigStore>((set) => ({
  loading: true,
  error: null,
  config: {},
  getConfig: async ({ chatToken }) => {
    try {
      set({ loading: true });
      const { data } = await getAppConfigApi({ chatToken });
      set({ config: data });
    } catch (error: unknown) {
      logger.error('Error fetching app config', {}, error as Error);
      set({
        error: {
          code: (error as AxiosError<{ message: string }>)?.status,
          message: (error as AxiosError<{ message: string }>)?.response?.data
            ?.message,
        },
      });
    } finally {
      set({ loading: false });
    }
  },
}));
